<body>
  <app-checklist [userRole]="userRole" [toggleStateSubject]="checklistStateSubject"></app-checklist>
  <pending-survey [isSingle]="isSingle" [toggleStateSubject]="surveyStateSubject"></pending-survey>
  <router-outlet></router-outlet>
</body>
